<template>
    <v-container>
        <v-row>
            <v-col>
            </v-col>
        </v-row>
        <v-row>
            <v-col align="stretch">
                <h1 class="text-center align-center font-weight-thin display-3">Welcome Zeta!</h1>
                <p class="text-center font-weight-light display-1">Please sign in to use the generator.</p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'AppLanding'
}
</script>

<style scoped>

</style>
